import { Injectable } from '@angular/core';
import { AccessCardFiltersInterface } from '@zaoblako/shared/modules/pacs/dtos/access-card/access-card-filters.dto';
import { AccessCardFindInterface } from '@zaoblako/shared/modules/pacs/dtos/access-card/access-card-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccessCardService extends BaseService {
  protected baseUrl = '/pacs/base/access-card';

  public findByUser(queryParams: AccessCardFiltersInterface): Observable<AccessCardFindInterface[]> {
    return this.http.get<AccessCardFindInterface[]>(`${this.baseUrl}/all`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
